import Vue from 'vue';
import JsonEditor from 'vue-json-edit';
import VJsoneditor from 'v-jsoneditor';

Vue.use(JsonEditor);
Vue.use(VJsoneditor);